<template>
    <div>
        <base-crud
            :ref="table"
            :crudName="crudName"
            :newText="newText"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="false"
            :enableEdit="false"
            :enableDelete="false"
            :enableView="false"
            :dataForm="dataForm"
            :extra="extra"
            @viewAnalisis="viewAnalisis"
        ></base-crud>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
export default {
    data() {
        return {
            crudName: "Visualize ou faça análises nas Pesquisas de Clima",
            newText: "Cadastrar Análise",
            table: "analisisTable",
            columns: ["id", "name", "cycle_id", "status_id", "actions"],
            tableData: ["id", "name", "cycle_id", "status_id"],
            options: {
                filterByColumn: true,
                debounce: 1000,
                sortable: ["id", "name", "cycle_id", "status_id"],
                filterable: ["id", "name", "cycle_id", "status_id"],
                pagination: { chunk: 10, dropdown: false, nav: "scroll" },
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: "#",
                    name: "Nome",
                    cycle_id: "Ciclo",
                    status_id: "Status",
                    actions: "Ações"
                },
                templates: {
                    cycle_id(h, row, index) {
                        return row.cycle.name;
                    },
                    status_id(h, row, index) {
                        return row.status.name;
                    }
                },
                requestFunction: function(data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = ['cycle', 'status'];

                    return this.$http
                        .get(this.url + "?" + query, requestData)
                        .catch(
                            function(e) {
                                this.dispatch("error", e);
                            }.bind(this)
                        );
                }
            },
            endPoint: "researches/",
            dataForm: {},
            extra: [
                {
                    id: 1,
                    label: "",
                    class: "btn btn-crud extra-one",
                    title: "Análises",
                    name: "viewAnalisis",
                    icon: "fas fa-eye"
                }
            ]
        };
    },
    methods: {
        viewAnalisis(props) {
            this.$router.push("/analyse/" + props.row.id);
        },
        query: function(query) {
            let columns = {
                id: "id",
                name: "name",
                cycle_id: "cycle_id",
                status_id: "status_id"
            };
            let filters = "";
            $.each(query, function(index, value) {
                filters += columns[index] + "=" + value + "&";
            });

            return filters;
        }
    },
    mounted() {
        const self = this;
    },
    components: {
        BaseCrud
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Analisis/Crud.vue